// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckoutPage_root__IdmQE","submitButton":"CheckoutPage_submitButton__1e2II","grid":"CheckoutPage_grid__10EnG","tabs":"CheckoutPage_tabs__cToF5"};